/* Latest-request image loading for the product turntable; no background preload. */
(() => {
  'use strict';
  class ViewLoader {
    constructor({urls,show,busy=()=>{},error=()=>{},makeImage=()=>new Image(),limit=6,concurrency=2,timeout=10000}) {
      Object.assign(this,{urls,show,busy,error,makeImage,limit,concurrency,timeout});
      this.cache=new Map();this.pending=new Map();this.wanted=null;this.active=true;
    }
    select(index) {
      if(!this.active)return;
      this.wanted=(Math.round(index)%this.urls.length+this.urls.length)%this.urls.length;
      const cached=this.cache.get(this.wanted);
      if(cached){this.cache.delete(this.wanted);this.cache.set(this.wanted,cached);this.show(this.wanted,this.urls[this.wanted]);this.busy(false);}
      else {this.busy(true);this.pump();}
    }
    pump() {
      const index=this.wanted;
      if(!this.active||index===null||this.cache.has(index)||this.pending.has(index)||this.pending.size>=this.concurrency)return;
      const image=this.makeImage(),job={image,timer:null};
      this.pending.set(index,job);
      image.decoding='async';image.src=this.urls[index];
      const finish=ok=>{
        if(this.pending.get(index)!==job)return;
        clearTimeout(job.timer);this.pending.delete(index);
        if(ok){
          this.cache.delete(index);this.cache.set(index,image);
          while(this.cache.size>this.limit){
            const key=[...this.cache.keys()].find(key=>key!==this.wanted);
            this.cache.get(key).removeAttribute('src');this.cache.delete(key);
          }
          if(index===this.wanted){this.show(index,this.urls[index]);this.busy(false);}
        }else{
          image.removeAttribute('src');
          if(index===this.wanted){this.wanted=null;this.busy(false);this.error();}
        }
        this.pump();
      };
      job.timer=setTimeout(()=>finish(false),this.timeout);
      Promise.resolve().then(()=>image.decode()).then(()=>finish(true),()=>finish(false));
    }
    suspend() {
      this.active=false;this.wanted=null;
      for(const {image,timer} of this.pending.values()){clearTimeout(timer);image.removeAttribute('src');}
      for(const image of this.cache.values())image.removeAttribute('src');
      this.pending.clear();this.cache.clear();this.busy(false);
    }
    resume(){this.active=true;}
  }
  if(typeof module!=='undefined'&&module.exports){module.exports={ViewLoader};return;}
  const loaders=new Set(),instances=new WeakMap();
  function mount(view){
    if(instances.has(view))return;
    const events=new AbortController();
    const listen=(target,type,fn)=>target.addEventListener(type,fn,{signal:events.signal});
    const urls=JSON.parse(view.querySelector('[data-view-frames]').textContent),
      image=view.querySelector('[data-view-image]'),drag=view.querySelector('.viewer-drag'),output=view.querySelector('output');
    let index=Number(drag.getAttribute('aria-valuenow'))||0,shown=index,pointer=null;
    const label=value=>{drag.setAttribute('aria-valuenow',String(value));drag.setAttribute('aria-valuetext',`${value*5}°`);output.textContent=`${value*5}°`;};
    label(shown);
    const loader=new ViewLoader({urls,
      show:(value,url)=>{image.src=url;shown=value;label(value);},
      busy:value=>view.setAttribute('aria-busy',String(value)),
      error:()=>{index=shown;const status=document.getElementById('global-status');if(status)status.textContent=view.dataset.viewError;}
    });
    loaders.add(loader);
    function set(value){index=(Math.round(value)%urls.length+urls.length)%urls.length;loader.select(index);}
    view.querySelectorAll('[data-view-step]').forEach(button=>listen(button,'click',()=>set(index+Number(button.dataset.viewStep))));
    listen(drag,'pointerdown',event=>{if(event.button!==0)return;pointer={id:event.pointerId,x:event.clientX,index};drag.setPointerCapture(event.pointerId);});
    listen(drag,'pointermove',event=>{if(pointer?.id===event.pointerId)set(pointer.index+(event.clientX-pointer.x)/drag.clientWidth*urls.length);});
    ['pointerup','pointercancel','lostpointercapture'].forEach(type=>listen(drag,type,()=>pointer=null));
    listen(drag,'keydown',event=>{
      if(!['ArrowLeft','ArrowRight','Home','End'].includes(event.key))return;
      event.preventDefault();set(event.key==='Home'?0:event.key==='End'?urls.length-1:index+(event.key==='ArrowLeft'?-1:1));
    });
    view.dataset.viewReady='true';
    instances.set(view,()=>{
      events.abort();loader.suspend();loaders.delete(loader);pointer=null;
      view.removeAttribute('data-view-ready');instances.delete(view);
    });
  }
  const within=parent=>[...(parent.matches?.('[data-product-viewer]')?[parent]:[]),...parent.querySelectorAll('[data-product-viewer]')];
  within(document).forEach(mount);
  document.addEventListener('shopify:section:load',event=>within(event.target).forEach(mount));
  document.addEventListener('shopify:section:unload',event=>within(event.target).forEach(view=>instances.get(view)?.()));
  addEventListener('pagehide',()=>loaders.forEach(loader=>loader.suspend()));
  addEventListener('pageshow',event=>{if(event.persisted)loaders.forEach(loader=>loader.resume());});
})();
